import Smooth from 'smooth-scroll';

import { Component } from '../core/component';

export class SmoothScroll extends Component {
    selector = 'a[href*="#"]';

    init() {
        // eslint-disable-next-line no-new
        new Smooth(this.selector, {
            offset: 100,
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/SmoothScroll.js